import { render, staticRenderFns } from "./AccRelatedRequests.vue?vue&type=template&id=6e8b50a8&scoped=true&"
import script from "./AccRelatedRequests.vue?vue&type=script&lang=js&"
export * from "./AccRelatedRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8b50a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2141801166/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e8b50a8')) {
      api.createRecord('6e8b50a8', component.options)
    } else {
      api.reload('6e8b50a8', component.options)
    }
    module.hot.accept("./AccRelatedRequests.vue?vue&type=template&id=6e8b50a8&scoped=true&", function () {
      api.rerender('6e8b50a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Devices/Accessories/AccRelatedRequests.vue"
export default component.exports